
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Autocomplete, Button, Grid, MenuItem, TextField } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { startSavingConsumo, startSavingDescuento } from "../../../../services";
import { useBodegaXGranja, useLoteDistriXID, useProductosTodos } from "../../../../hooks";

import Swal from "sweetalert2";
import dayjs from "dayjs";





export const FormCreateConsumo = () => {


    const { id } = useParams();
    const queryClient = useQueryClient();
    const { productosTodosQuery } = useProductosTodos();
    const { loteDistriXIDQuery } = useLoteDistriXID(`${id}`);
    const { bodegaXGranjaQuery } = useBodegaXGranja(loteDistriXIDQuery.data.granja);

        

    const [formLote, setFormLote] = useState({fecha: '', cantidad: '', producto: null, bodega: ''})
    const { fecha, cantidad, producto, bodega } = formLote;
    const handleChangeInput = ({ target }) => {
        setFormLote({...formLote,[target.name]: target.value});
    }


    const handleChangeFecha = (value) => {
        if (!value || !dayjs(value).isValid()) return;
        const withTime = dayjs(value).set('hour', dayjs().hour()).set('minute', dayjs().minute()).set('second', dayjs().second());
        setFormLote({ ...formLote, fecha:  withTime.toISOString() });
    };


    
    const crearActInformacion = async(e) => {
        e.preventDefault();
        if([cantidad, producto, bodega].includes('') ){
            return Swal.fire('Error', 'Los datos del fromulario son obligatorios', 'error');
        }
        await Swal.fire({
            title: `Crear Consumo`,
            text: `¿Esta seguro de crear consumo?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si Crear`
        }).then( async( _ ) => {
            const resp = await startSavingConsumo({...formLote, id});
            if(resp){
                setFormLote({fecha: null, cantidad: '', producto: null, bodega: ''}); 
                queryClient.invalidateQueries({queryKey: ['consumo-lote']});
            }
        });
    }




    return (

        <form onSubmit={ crearActInformacion } >
            <Grid container spacing={ 2 }>

                <Grid item xs={12}>
                    <Autocomplete
                        name='producto'
                        value={ productosTodosQuery.data?.find(p => p.id === producto) || null }
                        options={ productosTodosQuery.data || [] }
                        onChange={(_, newValue) => {
                            handleChangeInput({ target: {name: 'producto', value: newValue.id || ''} });
                        }}
                        renderInput={(params) => <TextField autoComplete="off" {...params} label='Producto' />}
                        getOptionLabel={(option) => option.nombre }
                        size="small"
                    />
                </Grid>


                <Grid item xs={12}>
                    <TextField
                        required
                        select
                        label="Seleccione Bodega"
                        fullWidth
                        name="bodega"
                        value={bodega || ''}
                        onChange={handleChangeInput}
                        size="small"
                    >
                        <MenuItem value="">Seleccione Bodega</MenuItem>
                        {Array.isArray(bodegaXGranjaQuery?.data) && bodegaXGranjaQuery.data.length > 0 ? (
                            bodegaXGranjaQuery.data.map((g) => (
                                <MenuItem key={g.id} value={g.id}> {g.nombre} </MenuItem>
                            ))
                        ) : (
                            <MenuItem disabled>No hay bodegas disponibles</MenuItem>
                        )}
                    </TextField>
                </Grid>

                <Grid item xs={12}>
                    <TextField required
                        label='Cantidad'
                        type='Number'
                        placeholder='Cantidad'
                        fullWidth
                        name='cantidad'
                        value={ cantidad }
                        onChange={ handleChangeInput }
                        size="small"
                    />
                </Grid>

                <Grid item xs={12}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Fecha"
                            value={fecha || null}
                            onChange={ handleChangeFecha }
                            renderInput={ (params) => <TextField {...params} fullWidth size="small" /> }
                        />
                    </LocalizationProvider>
                </Grid>

            </Grid>

            <Grid container sx={{ my:4 }} direccion='column' justifyContent='center'>
                <Grid item xs={12} sm={8}>
                    <Button variant='contained' fullWidth type='submit'>
                        Crear Consumo
                    </Button>
                </Grid>
            </Grid>
        </form>

    )
}
